<template>
  <div class="category-content">
    <div @click="addCat" class="flex-center" v-if="model === 'NORMAL'">
      <a-tooltip :mouseEnterDelay="0.5" placement="right">
        <template slot="title"> 新增顶级书签分类 </template>
        <a-button type="primary">新增分类</a-button>
      </a-tooltip>
    </div>
    <div>
      <a-empty v-if="addCatBtnShow" />
    </div>
    <div id="components-a-tooltip-demo-placement">
      <div>
        <a-dropdown :trigger="['contextmenu']">
          <template>
            <a-directory-tree
              class="draggable-tree"
              draggable
              :tree-data="gData"
              showIcon
              @dragenter="onDragEnter"
              @drop="onDrop"
              @rightClick="onRightClick"
              @select="onSelect"
            >
            </a-directory-tree>
          </template>

          <a-menu slot="overlay" class="menu-list" v-if="model === 'NORMAL'">
            <a-menu-item>
              <div @click="update()">修改</div>
            </a-menu-item>

            <a-menu-item>
              
            <div @click="openDeleteConfirm">删除</div>

            </a-menu-item>

            <a-menu-item>
              <div @click="addChild()" class="part-tail">新增子分类</div>
            </a-menu-item>

            <a-menu-item>
             <div @click="openCleanConfirm">清空分类下书签</div>

            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div>
      <template>
        <div>
          <a-modal
            title="新增分类"
            placement="right"
            :closable="false"
            v-model="addCatVisible"
            width="400px"
            okText="确认"
            cancelText="取消"
            @ok="handleSubmit"
          >
            <a-form
              :form="form"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              centered
            >
              <a-form-item label="分类名称">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      initialValue: currentCat.name,
                      rules: [{ required: true, message: '请输入分类名称!' }],
                    },
                  ]"
                />
              </a-form-item>
            </a-form>
          </a-modal>
        </div>
      </template>
    </div>
    <div id="model-area">
      <Confirm ref="deleteConfirm"  content="确认删除该分类？" :ok="deleteCat"/>
      <Confirm ref="cleanConfirm"  content="是否清空该分类下的所有书签(不包含子分类)？" :ok="cleanFavs"/>
    </div>
  </div>
</template>


<script>
import Confirm from './common/confirm';
export default {
  data() {
    return {
      gData: [],
      addCatVisible: false,
      currentCat: {},
      clickId: "",
      catsMap: {},
      emptyFav: { name: "", url: "", sort: "" },
      visible:false,
      formLayout: "horizontal",
      form: this.$form.createForm(this, { name: "coordinated" }),
    };
  },
  props: ["currentCategory", "model"],
  components:{Confirm},
  methods: {
    sysParent(category) {
      this.$emit("change", category);
    },
    onDragEnter(info) {
      // console.log(info)
      // expandedKeys 需要受控时设置
      // this.expandedKeys = info.expandedKeys
    },
    onDrop(info) {
      const dropKey = info.node.eventKey;
      const dragKey = info.dragNode.eventKey;
      const dropPos = info.node.pos.split("-");
      let pid = dropKey;
      let dropObj = this.catsMap[dropKey];
      let sort = this.catsMap[dragKey].sort;
      const dropPosition =
        info.dropPosition - Number(dropPos[dropPos.length - 1]);
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr);
          }
          if (item.children) {
            return loop(item.children, key, callback);
          }
        });
      };
      const data = [...this.gData];
      // Find dragObject
      let dragObj;
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1);
        dragObj = item;
      });
      if (!info.dropToGap) {
        // Drop on the content
        loop(data, dropKey, (item) => {
          item.children = item.children || [];
          // where to insert 示例添加到尾部，可以是随意位置
          item.children.push(dragObj);
        });
      } else if (
        (info.node.children || []).length > 0 && // Has children
        info.node.expanded && // Is expanded
        dropPosition === 1 // On the bottom gap
      ) {
        loop(data, dropKey, (item) => {
          item.children = item.children || [];
          // where to insert 示例添加到尾部，可以是随意位置
          item.children.unshift(dragObj);
        });
        pid = dropObj.pid;
      } else {
        let ar;
        let i;
        loop(data, dropKey, (item, index, arr) => {
          ar = arr;
          i = index;
        });
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj);
          pid = dropObj.pid;
        } else {
          ar.splice(i + 1, 0, dragObj);
        }
        pid = dropObj.pid;
        sort = dropObj.sort - dropPosition;
      }
      this.gData = data;
      let updateObj = {
        id: dragKey,
        pid: pid,
        sort: sort,
      };
      this.$req.post("/api/category/update", updateObj, (res) => {});
    },
    listToTree(list, pid) {
      let menuObj = {};
      list.forEach((item) => {
        item.title = item.name;
        item.key = item.id;
        item.children = [];
        menuObj[item.id] = item;
      });
      this.catsMap = menuObj;
      return list.filter((item) => {
        if (item.pid !== pid && item.pid != -1) {
          menuObj[item.pid].children.push(item);
          return false;
        }
        return true;
      });
    },
    onRightClick(event, node) {
      this.clickId = event.node.eventKey;
    },
    onSelect(selectedKeys) {
      this.clickId = selectedKeys[0];
      this.$emit("refresh", this.clickId);
      this.sysParent(this.catsMap[this.clickId]);
    },
    closeAddCat() {
      this.addCatVisible = false;
      this.form.resetFields();
    },
    showAddCat() {
      this.addCatVisible = true;
    },
    addCateSubmit() {
      this.$req.post("/api/category/save", this.currentCat, (res) => {
        this.searchCats();
        this.closeAddCat();
      });
    },
    addChild() {
      this.currentCat = {
        pid : this.clickId
      }
      this.showAddCat();
    },
    addCat() {
      this.currentCat = {
        pid: -1,
      };
      this.showAddCat();
    },
    openDeleteConfirm(){
      this.$refs.deleteConfirm.show();
    },
    deleteCat() {
      this.$req.get("/api/category/delete/" + this.clickId, {}, (res) => {
        this.currentCat={};
        this.searchCats();
      });
    },
    searchCats() {
      this.$req.get("/api/category/list", {}, (res) => {
        let cats = this.listToTree(res.data, -1);
        this.gData = cats;
      });
    },
    update() {
      this.currentCat = this.catsMap[this.clickId];
      this.showAddCat();
    },
    openCleanConfirm(){
       this.$refs.cleanConfirm.show();
    },
    cleanFavs() {
      this.$req.get("/api/favorites/clean-favs/" + this.clickId, {}, (res) => {
        this.$message.success("清空成功！");
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.currentCat.name = values.name;
          this.currentCat.sort = values.sort;
          this.addCateSubmit();
        }
      });
    },
  },
  computed: {
    addCatBtnShow: function () {
      return this.gData.length == 0;
    },
  },
  created: function () {
    this.searchCats();
  },
};
</script>
<style scoped>
#add-file-icon {
  font-size: 20px;
}
.category-content{
  padding-top: 20px;
}
</style>